import React, {useState, useEffect} from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  NavLink,
  Outlet,
  Navigate,
} from "react-router-dom";
import {Container, Row, Col, Nav} from "react-bootstrap";
// Importamos iconos para el nuevo menú profesional
import {
  FaTachometerAlt,
  FaUsers,
  FaBullhorn, // Icono para comunicaciones
  FaUserFriends, // Icono para audiencias
  FaBuilding, // Icono para organizaciones
  FaInbox, // Icono para bandeja de entrada
  FaChartLine, // Icono para analytics
  FaLifeRing, // Icono para Soporte
  FaQuestionCircle, // Icono para Soporte
  FaGift, // Icono para beneficios
  FaFileAlt, // Icono para plantillas
} from "react-icons/fa";
import "./App.css"; // Importamos la nueva página de Contactos
// Importamos la nueva página de Contactos
import Contacts from "./pages/Contacts";
import CommunicationCreator from "./pages/CommunicationCreator"; // Importamos el creador de comunicaciones
import Dashboard from "./pages/Dashboard"; // Importamos el nuevo Dashboard
import Settings from "./pages/Settings";
import Profile from "./pages/Profile"; // Importamos la nueva página de Perfil
import Incentives from "./pages/Incentives"; // Importamos la página de incentivos
import Organizations from "./pages/Organizations"; // Importamos la página de organizaciones
import CommunicationDetail from "./pages/CommunicationDetail"; // Importamos el detalle de comunicación
import Login from "./pages/Login"; // Importamos la página de Login
import HelpCenter from "./pages/HelpCenter"; // Importamos el nuevo Centro de Ayuda
import Support from "./pages/Support"; // Importamos la nueva página de Soporte
import OperatorHub from "./pages/OperatorHub";
import InboxWhatsApp from "./pages/InboxWhatsApp"; // Importamos la nueva Bandeja de Entrada estilo WhatsApp
import Templates from "./pages/Templates"; // Importamos la página de Plantillas
import mockNotifications from "./data/notifications.json"; // Importamos las notificaciones
import Header from "./components/Header"; // Importamos el nuevo Header
import mockIncentivesData from "./data/incentives.json";
import mockCampaignsData from "./data/campaigns.json";
import mockContactsData from "./data/contacts.json";
import mockOrganizationsData from "./data/organizations.json";
import mockListsData from "./data/broadcastLists.json";
import mockEventsData from "./data/events.json";
import Analytics from "./pages/Analytics"; // Importamos la nueva página de Analytics
import Lists from "./pages/Lists";
import PublicSubscription from "./pages/PublicSubscription"; // Importamos la página pública de suscripción
import ClientSelector from "./pages/ClientSelector"; // Importamos el selector de cliente
import clientsData from "./data/clients.json"; // Importamos los datos de clientes
import "react-calendar/dist/Calendar.css"; // Importamos los estilos del calendario

// --- Componente Sidebar ---
const Sidebar = () => (
  <Nav
    className="flex-column p-3 sidebar-custom"
    style={{
      position: "fixed",
      width: "250px",
      overflowY: "auto",
      top: "60px", // Empezar debajo del header
      height: "calc(100vh - 60px)", // Altura total menos el header
      zIndex: 1020,
    }}
  >
    <span className="text-white-50 small text-uppercase mb-2">Principal</span>
    <Nav.Item>
      <Nav.Link as={NavLink} to="/dashboard" end>
        <FaTachometerAlt className="me-2" /> Dashboard
      </Nav.Link>
    </Nav.Item>
    <Nav.Item>
      <Nav.Link as={NavLink} to="/communications" end>
        <FaBullhorn className="me-2" /> Comunicaciones
      </Nav.Link>
    </Nav.Item>
    <Nav.Item>
      <Nav.Link as={NavLink} to="/inbox">
        <FaInbox className="me-2" /> Bandeja de Entrada
      </Nav.Link>
    </Nav.Item>

    <span className="text-white-50 small text-uppercase mt-3 mb-2">
      Gestión de Audiencias
    </span>
    <Nav.Item>
      <Nav.Link as={NavLink} to="/contacts">
        <FaUsers className="me-2" /> Contactos
      </Nav.Link>
    </Nav.Item>
    <Nav.Item>
      <Nav.Link as={NavLink} to="/organizations">
        <FaBuilding className="me-2" /> Organizaciones
      </Nav.Link>
    </Nav.Item>
    <Nav.Item>
      <Nav.Link as={NavLink} to="/audiences">
        <FaUserFriends className="me-2" /> Audiencias
      </Nav.Link>
    </Nav.Item>

    <span className="text-white-50 small text-uppercase mt-3 mb-2">
      Herramientas
    </span>
    <Nav.Item>
      <Nav.Link as={NavLink} to="/templates">
        <FaFileAlt className="me-2" /> Plantillas
      </Nav.Link>
    </Nav.Item>
    <Nav.Item>
      <Nav.Link as={NavLink} to="/benefits">
        <FaGift className="me-2" /> Beneficios
      </Nav.Link>
    </Nav.Item>
    <Nav.Item>
      <Nav.Link as={NavLink} to="/analytics">
        <FaChartLine className="me-2" /> Analytics
      </Nav.Link>
    </Nav.Item>

    <span className="text-white-50 small text-uppercase mt-3 mb-2">
      Soporte
    </span>
    <Nav.Item>
      <Nav.Link as={NavLink} to="/help">
        <FaQuestionCircle className="me-2" /> Centro de Ayuda
      </Nav.Link>
    </Nav.Item>
    <Nav.Item>
      <Nav.Link as={NavLink} to="/support">
        <FaLifeRing className="me-2" /> Soporte
      </Nav.Link>
    </Nav.Item>
  </Nav>
);

// Componente para envolver las páginas con el Header
const PageLayout = () => {
  return <Outlet />;
};

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(
    () => localStorage.getItem("isLoggedIn") === "true"
  );
  const [notifications, setNotifications] = useState(mockNotifications);
  const [communications, setCommunications] = useState(mockCampaignsData);
  const [contacts, setContacts] = useState(mockContactsData);
  const [incentives, setIncentives] = useState(mockIncentivesData);
  const [organizations, setOrganizations] = useState(mockOrganizationsData);
  const [lists, setLists] = useState(mockListsData);
  const [events, setEvents] = useState(mockEventsData);
  const [activeClient, setActiveClient] = useState(null);

  // Efecto para cambiar el título de la página
  useEffect(() => {
    document.title = "PorterCom - Plataforma de Comunicaciones";
  }, []);

  // Simular la llegada de nuevas notificaciones
  useEffect(() => {
    if (isAuthenticated) {
      const interval = setInterval(() => {
        // Lógica para añadir una nueva notificación (aquí se podría llamar a una API)
      }, 30000); // Cada 30 segundos
      return () => clearInterval(interval);
    }
  }, [isAuthenticated]);

  const handleAuthSuccess = () => {
    localStorage.setItem("isLoggedIn", "true");
    const userClients = clientsData;

    if (userClients.length === 1) {
      handleClientSelect(userClients[0]);
    } else {
      setIsAuthenticated(true);
    }
  };

  const handleClientSelect = (client) => {
    setActiveClient(client);
    // En una app real, aquí se recargarían los datos (organizaciones, contactos, etc.)
    // filtrados por el `client.id`.
    console.log(`Contexto cambiado al cliente: ${client.name}`);
  };

  // Esta es la función que faltaba. Se encarga de actualizar el cliente activo.
  const handleClientChange = (client) => {
    console.log("Cambiando a cliente:", client.name);
    setActiveClient(client);
    // Aquí también podrías recargar los datos específicos del cliente si es necesario.
  };

  const handleLogout = () => {
    localStorage.removeItem("isLoggedIn");
    setIsAuthenticated(false);
    setActiveClient(null);
  };

  const handleNotificationClick = (id) => {
    setNotifications(
      notifications.map((n) => (n.id === id ? {...n, read: true} : n))
    );
  };

  return (
    <Router>
      <Routes>
        {/* Rutas públicas - No requieren autenticación y ahora reciben las listas */}
        <Route
          path="/subscribe/:audienceId"
          element={<PublicSubscription lists={lists} />}
        />
        <Route
          path="/join/:audienceId"
          element={<PublicSubscription lists={lists} />}
        />

        {/* Ruta de login */}
        <Route
          path="/login"
          element={
            !isAuthenticated ? (
              <Login onAuthSuccess={handleAuthSuccess} />
            ) : activeClient ? (
              <Navigate to="/" />
            ) : (
              <ClientSelector
                onClientSelect={handleClientSelect}
                onLogout={handleLogout}
              />
            )
          }
        />

        {/* Rutas privadas - Requieren autenticación */}
        <Route
          path="/*"
          element={
            activeClient ? (
              <MainLayout
                onLogout={handleLogout}
                notifications={notifications}
                onNotificationClick={handleNotificationClick}
                activeClient={activeClient}
                onClientChange={handleClientChange} // Pasamos la nueva función
                clients={clientsData}
                communications={communications}
                setCommunications={setCommunications}
                incentives={incentives}
                setIncentives={setIncentives}
                contacts={contacts}
                setContacts={setContacts}
                organizations={organizations}
                setOrganizations={setOrganizations}
                lists={lists}
                setLists={setLists}
                events={events}
                setEvents={setEvents}
              />
            ) : (
              <Navigate to="/login" />
            )
          }
        />
      </Routes>
    </Router>
  );
}

// Creamos un componente para el layout principal de la aplicación
const MainLayout = ({
  onLogout,
  notifications,
  onNotificationClick,
  onClientChange,
  activeClient,
  clients,
  communications,
  setCommunications,
  incentives,
  setIncentives,
  contacts,
  setContacts,
  organizations,
  setOrganizations,
  lists,
  setLists,
  events,
  setEvents,
}) => (
  <>
    {/* Header fijo en la parte superior */}
    <Header
      onLogout={onLogout}
      notifications={notifications}
      onNotificationClick={onNotificationClick}
      activeClient={activeClient}
      clients={clients}
      onClientChange={onClientChange}
    />

    <Container fluid style={{paddingTop: "60px"}}>
      <Row>
        <Col md={3} lg={2} className="p-0" style={{position: "fixed"}}>
          <Sidebar />
        </Col>
        <Col md={9} lg={10} style={{marginLeft: "250px", paddingLeft: 0}}>
          <main
            style={{
              paddingTop: "20px",
              paddingLeft: "24px",
              paddingRight: "24px",
            }}
          >
            <Routes>
              <Route element={<PageLayout />}>
                <Route
                  path="/"
                  element={
                    <Dashboard
                      campaigns={communications}
                      contacts={contacts}
                      lists={lists}
                      incentives={incentives}
                      organizations={organizations}
                    />
                  }
                />
                <Route
                  path="/dashboard"
                  element={
                    <Dashboard
                      campaigns={communications}
                      contacts={contacts}
                      lists={lists}
                      incentives={incentives}
                      organizations={organizations}
                    />
                  }
                />
                <Route
                  path="/communications"
                  element={
                    <OperatorHub
                      campaigns={communications}
                      setCampaigns={setCommunications}
                      contacts={contacts}
                      lists={lists}
                    />
                  }
                />
                <Route
                  path="/contacts"
                  element={
                    <Contacts
                      contacts={contacts}
                      setContacts={setContacts}
                      organizations={organizations}
                    />
                  }
                />
                <Route
                  path="/organizations"
                  element={
                    <Organizations
                      organizations={organizations}
                      setOrganizations={setOrganizations}
                      contacts={contacts}
                    />
                  }
                />
                <Route
                  path="/audiences"
                  element={
                    <Lists
                      lists={lists}
                      setLists={setLists}
                      contacts={contacts}
                      setContacts={setContacts}
                    />
                  }
                />
                <Route
                  path="/communications/new"
                  element={
                    <CommunicationCreator
                      setCommunications={setCommunications}
                      communications={communications}
                      incentives={incentives}
                      lists={lists}
                      contacts={contacts}
                    />
                  }
                />
                <Route
                  path="/communications/edit/:communicationId"
                  element={
                    <CommunicationCreator
                      setCommunications={setCommunications}
                      communications={communications}
                      incentives={incentives}
                      lists={lists}
                      contacts={contacts}
                    />
                  }
                />
                <Route
                  path="/communications/:communicationId"
                  element={
                    <CommunicationDetail
                      communications={communications}
                      lists={lists}
                      contacts={contacts}
                      incentives={incentives}
                    />
                  }
                />
                <Route
                  path="/benefits"
                  element={
                    <Incentives
                      incentives={incentives}
                      setIncentives={setIncentives}
                      contacts={contacts}
                    />
                  }
                />
                <Route path="/inbox" element={<InboxWhatsApp />} />
                <Route path="/templates" element={<Templates />} />
                <Route
                  path="/analytics"
                  element={
                    <Analytics
                      campaigns={communications}
                      contacts={contacts}
                      lists={lists}
                    />
                  }
                />
                <Route path="/settings" element={<Settings />} />
                <Route path="/profile" element={<Profile />} />
                <Route path="/support" element={<Support />} />
                <Route path="/help" element={<HelpCenter />} />
              </Route>
              <Route path="*" element={<Navigate to="/" />} />
            </Routes>
          </main>
        </Col>
      </Row>
    </Container>
  </>
);

export default App;
